import { useQuery } from '@tanstack/react-query';
import { getIndexBlog } from 'services';
import { getLocalStorage } from 'untils/auth';

const sec = 1000;

export const useGetDashboardBlog = () =>
  useQuery({
    queryKey: ['blogs', 'dashboard-blog'],
    queryFn: getIndexBlog,
    select: (data) => {
      const blogs =
        data.data.blogs.map((blog) => {
          const picture = blog.Img
            ? `${process.env.REACT_APP_RESOURCE_URL}/${blog.Img}`
            : '/imgs/webp/home/popular-city.webp';

          return {
            ...blog,
            path: `/Blog/${blog?.info.url || blog?.info.blogId}`,
            picture,
          };
        }) || [];
      const [blog] = blogs;
      return blog;
    },
    staleTime: sec * 60 * 30,
  });
